import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData<T> {
    title: string,
    infos: T;
}

@Component({
    selector: 'app-parkinginfo',
    templateUrl: './parkinginfo.component.html',
    styleUrls: ['./parkinginfo.component.scss'],
    standalone: false
})
export class ParkinginfoComponent implements OnInit {
    datas = {
        CarParkName: '',
        Transfer: '',
        Address: '',
        ShuttleTimes: '',
        ShuttleFrequency: '',
        Special: '',
        ArrivalProcedure: '',
        DepartureProcedure: '',
        CarSizeInfo: '',
        Accessibility: '',
        SecurityInfo: '',
        Insurance: '',
        ChildSeat: '',
        DirectionsShort: '',
        MinimumParkingDays: '',
        MaximumParkingDays: '',
    };

    title: string = '';
    currentImage:number = 0;
    currentImagePosition:number = 0;
    desktopTemplate:boolean = false;
    constructor (@Inject(MAT_DIALOG_DATA) public data: DialogData<any>) { }

    ngOnInit (): void {
        this.title = this.data?.title;
        this.currentImagePosition = this.currentImage;
        if (this.data?.infos) {
          this.data?.infos?.infoList.forEach(element => {
              this.datas[String(element.key)] = element.value;
          });
        }
    }
}
